module.exports = __webpack_public_path__ + "static/videoimage-5e04d7e16fa99c04bcdd17fa3e418f50.png";